import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "badge-text-style" }

import { computed, toRefs } from 'vue';

// Personal libs
import { ChangelogEnum } from '@shared/enum/changelog.enum';
import { $t } from '@i18n/utils';

/**
 * Component properties
 */
interface Props {
  changelogType: ChangelogEnum;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QChangelogItem',
  props: {
    changelogType: { default: ChangelogEnum.ADDED }
  },
  setup(__props: any) {

// Vendor
const props = __props;
const { changelogType } = toRefs(props);

/**
 * Computed properties
 */
const bgColor = computed<string>(() => {
  switch (changelogType.value) {
    case ChangelogEnum.ADDED:
    case ChangelogEnum.CHANGED:
      return 'green';
    default:
      return 'blue';
  }
});
const textColor = computed<string>(() => 'black');
const content = computed<string>(() =>
  $t(`changelog.panels.${ChangelogEnum[changelogType.value].toLowerCase()}`),
);

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createBlock(_component_q_badge, {
    class: "badge-style text-center q-py-xs q-my-xs",
    color: bgColor.value,
    "text-color": textColor.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(content.value), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["color", "text-color"]))
}
}

})